import { useInView } from '../hooks/useInView';
import './AnimatedImageSection.css';

function AnimatedImageSection({ section, onInquiry }) {
  const [ref, inView] = useInView({ threshold: 0.08 });
  const aspectRatio = `${section.width} / ${section.height}`;

  return (
    <section
      ref={ref}
      className={`landing__section${section.inquiry ? ' landing__section--inquiry' : ''}`}
      style={{ aspectRatio }}
      aria-label={section.alt}
    >
      {section.slices.map((slice, index) => {
        const animClasses = slice.anim
          .split(/\s+/)
          .map((name) => `landing__slice--${name}`)
          .join(' ');

        return (
        <div
          key={`${section.src}-${slice.top}`}
          className={`landing__slice ${animClasses}${inView ? ' is-visible' : ''}`}
          style={{
            top: `${(slice.top / section.height) * 100}%`,
            height: `${(slice.height / section.height) * 100}%`,
            transitionDelay: `${index * 0.1}s`,
          }}
        >
          <img
            src={section.src}
            alt={index === 0 ? section.alt : ''}
            aria-hidden={index !== 0}
            draggable={false}
            style={{ marginTop: `${-(slice.top / section.width) * 100}%` }}
          />
        </div>
        );
      })}

      {section.inquiry ? (
        <>
          <button
            type="button"
            className="landing__hit landing__hit--cta"
            onClick={onInquiry}
            aria-label="아이로그 부스 도입 문의하기"
          />
          <a
            className="landing__hit landing__hit--start"
            href="https://iplay.kro.kr"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="아이로그 시작하기"
          />
        </>
      ) : null}
    </section>
  );
}

export default AnimatedImageSection;
